<template>
  <div>
 <!--
    Form allowinng creation and modification of contracts

    Development log
        2021 - Intial development   Bruce Talbot
        04/04/2022 - added filter to limit displayed contracts to those ending in the current year
 -->     
    <RwvMenu />
    <div id="app">
      <div>
        <h3 class="PageHeader">Contracts</h3>
        <input type="text" v-model="searchValue" placeholder="Search Customer" id="search-input"> 
                                                                                                    <!-- 04/04/2022 start -->                      
        Current Year Only <input type="checkbox" v-model="currentYear" @change="yearChange()" /> <br />
                                                                                                    <!-- 04/04/2022 end -->                      
        <table class="Customer-table DisplayTable">
          <thead>
              <tr>
                <th>Customer Id</th>
                 <th>Product code</th>
                <th>Voucher Code</th>
                <th>Voucher Expiry</th>
                <th class="contractProduct">Attributes</th>
                <th class="buttonCol" />
              </tr>
            </thead>
            <tbody>
              <tr height="30px">
                <td class="Contract-Customer-cell" >
                  <select v-model="customerId" class ="contractCustomer" @change="allDataEntered(customerId, productId, voucherExpiry, 'new')">
                      <option v-for="Customer in sortedCustomers"
                        v-bind:value="Customer.id"
                        v-bind:key="Customer.name"
                        >
                        {{Customer.name}}
                      </option>
                  </select>
                 </td>
                 <td class="Contract-Product-cell">
                   <select v-model="productId" class ="contractProduct" @change="allDataEntered(customerId, productId, voucherExpiry, 'new')">
                       <option v-for="Product in Products"
                         v-bind:value="Product.id"
                         v-bind:key="Product.code"
                         >
                         {{Product.code}}
                       </option>
                    </select>
                   </td>
                 <td class="Contract-Voucher-cell"></td>
                 <td class="Contract-VoucherExpiry-cell">
                    <input type="date"
                      v-model="voucherExpiry"
                      class="contractVoucherExpiry"
                      @change="allDataEntered(customerId, productId, voucherExpiry, 'new'); checkVoucherDate(voucherExpiry)">
                 </td>
                 <td class="contractAttributes">
                    <span v-for= "(customerAttribute, AttrIndex) in customerAttributes" :key="customerAttribute.name">
                      <input type="text" @change="AddNewContractAttribute($event.target.value, AttrIndex)">
                    </span>
                    <span v-if="customerAttributes.length === 0" class="contractAttributes">
                      <button v-if="editingId === null" class="plusbutton" v-on:click="AddAttribute(indexContract)"></button>
                      <button v-else class="plusbutton" hidden></button>
                    </span>
                 </td>
                 <td v-if="editingId != null" class="product-table-cell">
                    <button class="addrecordbutton icon btnDisabled" hidden></button>
                 </td>
                 <td v-else-if="AllData && editingId === null && attributesOK" class="product-table-cell">
                    <button v-on:click="createContract(customerId, productId, voucherExpiry, customerAttributes)" class="addrecordbutton icon" title="Add Contract"></button>
                 </td>
                 <td v-else class="product-table-cell">
                    <button class="addrecordbutton icon btnDisabled" title="Not all data has been entered to add record" disabled></button>
                 </td>
              </tr>
              <tr v-for= "(contract, indexContract) in sortedContracts" :key="indexContract" height="30px" data-is-editable="0">
                <td class="Contract-Customer-cell contractCustomer" >
                          {{contract.customer.name}}
                </td>
                <td class="Contract-Product-cell contractProduct" >
                         {{contract.product.code}}
                </td>

                <td class="Contract-Voucher-cell vaccinationVoucher">
                  {{contract.voucherCode}}
                </td>
                <td class="Contract-VoucherExpiry-cell">
                  <input type="date"
                    v-model="contract.voucherExpiry"
                    :readonly="editingId == indexContract ? false : true"
                    :class="editingId == indexContract ? 'contractVoucherExpiry editable' :'contractVoucherExpiry'"
                    @change="allDataEntered(contract.customerId, contract.productId, contract.voucherExpiry, 'update'); checkVoucherDate(contract.voucherExpiry)">
                </td>
                <td class="contractAttributes" >
                  <span v-for= "(customerAttribute, indexRow) in contract.customerAttributes" :key="indexRow">
                    <input type="text"
                      :value="customerAttribute.name"
                      :readonly="editingId == indexContract ? false : true"
                      :class="editingId == indexContract ? 'contractAttributes editable' :'contractAttributes'"
                      @change="UpdateAttributes(indexRow, $event.target.value, indexContract)">
                      <button v-if="editingId == null" class="attribbutton" @click="openModal(customerAttribute, contract.id, indexRow, indexContract)"  />
                      <button class="minusbutton" v-if="editingId == indexContract" v-on:click="RemoveAttribute(indexContract, indexRow)"></button>
                  </span>
                  <span class="contractAttributes">
                  <button class="plusbutton" v-if="editingId == indexContract" v-on:click="AddAttribute(indexContract)"></button>
                  </span>
                <td class="product-table-cell">
                    <span  v-if="editingId === null">
                      <button v-on:click="editItem(indexContract)" class="editbutton icon" title="Edit Contract"></button>
                      <button v-on:click="deleteContract(contract.id, contract.voucherCode, contract.customer.name, contract.product.code)" class="deletebutton icon" title="Delete Contract"></button>
                    </span>
                    <span v-else-if="editingId === indexContract">
                      <span v-if="AllData && attributesOK">
                        <button v-on:click="updateContract(contract.id, contract.customerId, contract.productId, contract.voucherExpiry, indexContract)" class="savebutton icon" title="Save"></button>
                      </span>
                      <span v-else>
                        <button class="savebutton icon btnDisabled" title="Not all data has been entered to save record" disabled></button>
                      </span>
                      <button v-on:click="canceledit(indexContract)" class="cancelbutton icon" title="Cancel"></button>
                    </span>
                    <span v-else>
                      <button class="editbutton icon btnDisabled" hidden></button>
                      <button class="deletebutton icon btnDisabled" hidden></button>
                    </span>
                </td>
              </tr>
            </tbody>
        </table>
    </div>
    <div v-if="message" class="errormessage">
      <table>
        <tr>
          <td>{{message}}</td>
        </tr>
      </table>
    </div>
    </div>
    <modal v-show="showModal" ref="modalName" id="modalContainer">
      <template v-slot:header>
        <h1>Attribute Maintenance</h1>
      </template>

      <template v-slot:body >
        <table class="modalTable">
          <tr>
            <th>
              <span style="color:blue">{{attributeLabel}}</span>
            </th>
          </tr>
            <tr v-for="attributeValue in sortedAttributes" v-bind:key="attributeValue.id">
              <td>
                <input class="modalinput" type=text :value="attributeValue.values" readonly>
                <button class="minusbutton"  @click="deleteAttributeValue(attributeValue.id)"/>
              </td>
            </tr>
          <tr>
            <td>
              <input type=text v-model="newAttributeValue">
              <button class="plusbutton" v-on:click="AddAttributeValue(attributeLabel, newAttributeValue)"></button>
            </td>
          </tr>
          <tr>
            <td class="errormessage">{{modalmessage}}</td>
          </tr>
        </table>
      </template>

      <template v-slot:footer class='modal-footer'>
        <div>
          <button @click="closeModal()">Close</button>
        </div>
      </template>
    </modal>

  </div>
</template>

<script>
import { API } from 'aws-amplify';
import { listContracts } from '../graphql/queries';
import { listCustomers } from '../graphql/queries';
import { listProducts } from '../graphql/queries';
import { createContract } from '../graphql/mutations';
import { updateContract } from '../graphql/mutations';
import { deleteContract } from '../graphql/mutations';
import { listVaccinations } from '../graphql/queries';
import { onCreateContract } from '../graphql/subscriptions';
import { additionalItemByContractId } from '../graphql/queries';
import { createAdditionalItem } from '../graphql/mutations';
import { deleteAdditionalItem } from '../graphql/mutations';
import RwvMenu from "@/components/TheMenu";
import commonFunctions from "@/components/commonFunctions";
import modal from "@/components/Modal";

export default {
  name: 'app',
  components:{
    RwvMenu,
    modal,
  },
  async created() {
  // console.log("created ...")
    const today = new Date();
    this.yearSelect = today.getFullYear()+'-01-01';

    this.getContracts();
    this.getCustomers();
    this.getProducts();
    this.subscribeCreate();
    },
    data() {
      return {
        Contracts: [],
        Customers: [],
        Products: [],
        attributeValues: [],
        Vaccinations: [],
        editingId: null,
        customerId: '',
        contractId: '',
        productId: '',
        id:'',
        voucherCode: '',
        voucherExpiry: '',
        message: '',
        modalmessage: '',
        customerAttributes: [],
        NewcustomerAttributes: [],
        Contract: [],
        AllData: false,
        attributesOK: true,
        ContractValid: false,
        indexContract: '',
        indexRow: '',
        showModal: false,
        attributeLabel: '',
        noAttributes: true,
        newAttributeValue: '',
        custAttrib: [],
        currentSort: 'customer.name',
        currentSortDir: 'asc',
        searchValue: '',
        currentYear: true,
        yearSelect: ''
      }
  },
   computed: {
    sortedAttributes: function() {
  //    console.log('sortedAttributes ...');
      return this.attributeValues.slice().sort((a,b) => {
        if(a["values"] === null | a["values"] === undefined) return 1;
        if(b["values"] === null | b["values"] === undefined) return -1;
        if(a["values"] < b["values"]) return -1;
        if(a["values"] > b["values"]) return 1;
        return 0;
        });
    },
    sortedContracts: function() {
      // console.log('sortedCustomers ...');
      if (this.currentSort.indexOf(".") > -1) {
        let split = this.currentSort.indexOf(".")
        let first=this.currentSort.substring(0, split)
        let second=this.currentSort.substring(split + 1, this.currentSort.length)
        return this.searchCustomers.slice().sort((a,b) => {
          let modifier = 1;
          if(this.currentSortDir === 'desc') modifier = -1;
          if(a[first][second] === null | a[first][second] === undefined) return 1 * modifier;
          if(b[first][second] === null | b[first][second] === undefined) return -1 * modifier;
          if(a[first][second].toLowerCase() < b[first][second].toLowerCase()) return -1 * modifier;
          if(a[first][second].toLowerCase() > b[first][second].toLowerCase()) return 1 * modifier;
          return 0;
        });       
      }
      return this.searchCustomers.slice().sort((a,b) => {
        let modifier = 1;
        if(this.currentSortDir === 'desc') modifier = -1;
        // console.log(a[this.currentSort], b[this.currentSort])
        if(a[this.currentSort] === null | a[this.currentSort] === undefined) return 1 * modifier;
        if(b[this.currentSort] === null | b[this.currentSort] === undefined) return -1 * modifier;
        if(a[this.currentSort.toLowerCase()] < b[this.currentSort.toLowerCase()]) return -1 * modifier;
        if(a[this.currentSort.toLowerCase()] > b[this.currentSort.toLowerCase()]) return 1 * modifier;
        return 0;
      });
    },
    sortedCustomers: function() {
  //    console.log('sortedAttributes ...');
      return this.Customers.slice().sort((a,b) => {
        if(a["name"] === null | a["name"] === undefined) return 1;
        if(b["name"] === null | b["name"] === undefined) return -1;
        if(a["name"] < b["name"]) return -1;
        if(a["name"] > b["name"]) return 1;
        return 0;
        });
    },
    searchCustomers() {
        let tempCustomers = this.Contracts
        
        if (this.searchValue != '' && this.searchValue) {
              tempCustomers = tempCustomers.filter((item) => {
                return item.customer.name
                  .toUpperCase()
                  .includes(this.searchValue.toUpperCase())
              })
            }
        return tempCustomers
      },
   },
  methods: {
    reset(){
//      Object.assign(this.$data, this.$options.data.apply(this));
      this.getContracts();
      this.getCustomers();
      this.getProducts();
    },
                                                        // 04/04/2022 start
   yearChange () {
 //     console.log("yearChange ...")
      if (this.currentYear){
        const today = new Date();
        this.yearSelect = today.getFullYear()+'-01-01';
      }
      else {
        this.yearSelect = '2020-01-01';
      }
      this.getContracts()
 //     console.log("yearChange end")
    },
                                                        // 04/04/2022 end
    async getContracts() {
 //      console.log("getContracts ...")
      
      try {
        var limit = 2000;
                                                        // 04/04/2022 start
        var filter = {voucherExpiry:{ gt: this.yearSelect}}
                                                        // 04/04/2022 end
        const Contracts = await API.graphql({
        query: listContracts,
                                                        // 04/04/2022 start
        variables: {limit: limit, filter: filter}
//        variables: {limit: limit}
                                                        // 04/04/2022 start
        });
        this.Contracts = Contracts.data.listContracts.items;
      }
      catch (error) {
        //console.log(error)
        this.message = commonFunctions.displayError(error);
      }
  //     console.log('getContracts end ...')
    },
    async getCustomers() {
      // console.log("getCustomers ...")
      try {
        var limit = 2000;
        const Customers = await API.graphql({
          query: listCustomers,
          variables: {limit: limit}
        });
        this.Customers = Customers.data.listCustomers.items;
      }
      catch (error) {
      //  console.log(error)
        this.message = commonFunctions.displayError(error);
      }
      // console.log('getCustomers end ...')
    },
    async getProducts() {
      // console.log("getProducts ...")
      try {
        var limit = 2000;
        const Products = await API.graphql({
          query: listProducts,
          variables: {limit: limit}
        });
        this.Products = Products.data.listProducts.items;
        // console.log("getProducts end ...")
      }
      catch (error) {
      //  console.log(error)
        this.message = commonFunctions.displayError(error);
      }
    },
                                                                // Create Contracts
    async createContract(customerId, productId, voucherExpiry, customerAttributes) {
 //      console.log("createContract ...")
      if (!customerId || !productId || !voucherExpiry) return;
      if (!this.checkVoucherDate(voucherExpiry)) return;
      this.message = ''
                                                                // Generate Checksum
      var goodVoucherCode = false;
      while (!goodVoucherCode) {
        var voucherCode = Math.floor(Math.random()*(999999-100001)+100000);
        var checkdigit = this.luhn_checksum(voucherCode)
        voucherCode = (voucherCode * 10) + checkdigit
                                                                  // check voucher code is unique
        try {
          let filter = {
              voucherCode: {eq: voucherCode},
          }
          const Contract = await API.graphql({
              query: listContracts,
              variables: {filter: filter}}
              );

          this.Contract = Contract.data.listContracts.items;
          if (!this.Contract[0]){
            goodVoucherCode = true;
          }
        }
        catch (error) {
        //  console.log(error)
          this.message = commonFunctions.displayError(error);
          return;
        }
      }
                                                                // Check for duplicates
      var voucherDate = new Date(voucherExpiry)
      var ExpiryYear = voucherDate.getFullYear() + "-01-01"
      try {
        let filter = {
            productId: {eq: productId},
            customerId: {eq: customerId},
            voucherExpiry: {gt: ExpiryYear}
        }
        const Contract = await API.graphql({
            query: listContracts,
            variables: {filter: filter}}
            );

        this.Contract = Contract.data.listContracts.items;
        if (this.Contract[0]){
          this.message = "A contract exists for this year, customer and product";
          return;
        }
      }
      catch (error) {
      //  console.log(error)
        this.message = commonFunctions.displayError(error);
        return;
      }
                                                               // Create Contract
     var i;
     var n = this.customerAttributes.length - 1;
     for (i = n; i >= 0; i--) {
//       console.log("attribute name - ", this.customerAttributes[i].name)
      if(this.customerAttributes[i].name == "" | this.customerAttributes[i].name == undefined ) {
          this.customerAttributes.splice(i,1)
       }
     }
  
     var UpdateValues
     UpdateValues = {customerId, productId, voucherExpiry, voucherCode, customerAttributes};

 //     console.log("Contract =", UpdateValues);
      try {
        await API.graphql({
          query: createContract,
          variables: {input: UpdateValues},
        });
                                                                  // Reset variables
        this.resetVariables();
        this.customerAttributes = [];
        // console.log('createContract end ...');
      }
      catch (error) {
      //  console.log(error)
        this.message = commonFunctions.displayError(error);
      }
    },
                                                              // Update view on create
    subscribeCreate () {
      // console.log('subscribeCreate ...')
      API.graphql({
      query: onCreateContract
      })
      .subscribe ({
        next: (items) => {
          const contract = items.value.data.onCreateContract;
          if (this.Contracts.some(item => item.name === contract.id)) return; // remove duplications
          this.Contracts = [...this.Contracts, contract];
        }
      })
      // console.log('subscribeCreate end')
      },
                                                              // Update Contracts
    async updateContract(id, customerId, productId, voucherExpiry, indexRow) {
      // console.log('updateContract ...')
      if (!customerId || !productId || !voucherExpiry) return;
      if (!this.checkVoucherDate(voucherExpiry)) return;
      this.message = ''
                                                                      // Check for duplicates
      var voucherDate = new Date(voucherExpiry)
      var ExpiryYear = voucherDate.getFullYear() + "-01-01"
      try {
        let filter = {
            productId: {eq: productId},
            customerId: {eq: customerId},
            voucherExpiry: {gt: ExpiryYear},
            id: {ne: id}
        }
        const Contract = await API.graphql({
            query: listContracts,
            variables: {filter: filter}}
            );

        this.Contract = Contract.data.listContracts.items;
        if (this.Contract[0]){
          this.message = "A contract exists for this year, customer and product";
          return;
        }
      }
      catch (error) {
      //  console.log(error)
        this.message = commonFunctions.displayError(error);
        return;
      }

      try {
        var UpdateValues
        const customerAttributes = this.NewcustomerAttributes
        UpdateValues = {id, customerId, productId, voucherExpiry, customerAttributes};
        this.sortedContracts[indexRow].customerAttributes = Array.from(this.NewcustomerAttributes)
        await API.graphql({
          query: updateContract,
          variables: {input: UpdateValues},
        });
        this.resetVariables();
        this.editingId = null;
        this.$forceUpdate();
      }
      catch (error) {
      //  console.log(error)
        this.message = commonFunctions.displayError(error);
      }
      // console.log('updateContract end ...');
    },
                                                                // Delete Contracts
    async deleteContract(id, vCode, customerName, productCode) {
      // console.log('deleteContract ...');
      if(confirm("Do you really want to delete the " + productCode + " contract for " + customerName + "?")) {
        try {
          var filter;
          filter = {
              voucherCode: {eq: vCode}
            }
          const Vaccination = await API.graphql({
             query: listVaccinations,
             variables: {filter: filter}
           });
          this.Vaccinations = Vaccination.data.listVaccinations.items;
          if (this.Vaccinations[0]){
            this.message = "Vaccination records exist for this contract. It can't be deleted.";
            return;
          }
          const deleteItem = {id};
          // console.log('contract =', deleteItem)
          await API.graphql({
            query: deleteContract,
            variables: {input: deleteItem},
          });
          this.getContracts()
        }
        catch (error) {
        //  console.log(error)
          this.message = commonFunctions.displayError(error);
        }
      }
      // console.log('deleteProduct end ...');
    },
                                                                // set row in edit mode
    editItem(indexRow) {
      // console.log('editItem ...');
      // console.log('indexContract = ', indexRow);
      this.message="";
      if (this.sortedContracts[indexRow].customerAttributes) {
        this.NewcustomerAttributes = Array.from(this.sortedContracts[indexRow].customerAttributes)
      }
      var i;
      var n = this.customerAttributes.length - 1;
      for (i = n; i >= 0; i--) {
          this.customerAttributes.splice(i,1)
      }
      this.resetVariables();
      this.editingId = indexRow;
      this.AllData = true;
      // console.log('editItem end');
    },
                                                                // Reset row to original values
    canceledit(indexRow) {
      // console.log('Cancel Edit ...');
      this.message="";
      var i;
      var n = this.sortedContracts[indexRow].customerAttributes.length - 1;
      for (i = n; i >= 0; i--) {
        if (this.sortedContracts[indexRow].customerAttributes[i] === "" || this.sortedContracts[indexRow].customerAttributes[i] == undefined){
          this.sortedContracts[indexRow].customerAttributes.splice(i,1)
        }
      }
      this.$forceUpdate();
      this.resetVariables();
      this.editingId = null;
      this.reset();
      // console.log('Cancel Edit end');
    },
                                                                // validate date is later than today
    checkVoucherDate(voucherExpiryDate) {
    //  console.log('checkVoucherDate ...');
      this.message="";
      const today = new Date();
      const date = new Date(today.getFullYear()+','+(today.getMonth()+1)+','+today.getDate());
      const vouchExpiry = new Date(voucherExpiryDate)
      const vouchDate = new Date(vouchExpiry.getFullYear()+','+(vouchExpiry.getMonth()+1)+','+vouchExpiry.getDate());
      if (vouchDate < date){
            this.message = "Voucher expiry must be in the future";
            this.AllData = false;
            return false;
          }
     return true;
    },
    UpdateAttributes(indexRow, customerAttributes, IndexContract) {
 //      console.log('UpdateAttributes ...');
 //      console.log(customerAttributes)
       if (!commonFunctions.xssTest(customerAttributes)) {
        this.message = commonFunctions.xssMessage("Attributes")
        this.attributesOK = false;
        return
      }
        else {
          this.attributesOK = true;
          this.message = ''
        }
      let custAttrib = {name: customerAttributes, multiList: false}
      this.NewcustomerAttributes.splice(indexRow, 1 , custAttrib)
      this.sortedContracts[IndexContract].customerAttributes.splice(indexRow, 1 , custAttrib)
      // console.log('UpdateAttributes end');
    },
    AddAttribute(indexItem) {
     // console.log('AddAttribute ...');
      if(indexItem !== null && indexItem !== undefined && indexItem !== "") {
        if(this.sortedContracts[indexItem].customerAttributes) {
          const NumAttributes = this.sortedContracts[indexItem].customerAttributes.length
          this.sortedContracts[indexItem].customerAttributes.splice(NumAttributes, 0 , "")
        }
        else {
          this.sortedContracts[indexItem].customerAttributes = new Array
          this.sortedContracts[indexItem].customerAttributes.push("")
        }
        this.NewcustomerAttributes = Array.from(this.sortedContracts[indexItem].customerAttributes)
      }
      else {
        this.customerAttributes.push("");
      }

      this.$forceUpdate();
  //     console.log('AddAttribute end');
    },
    RemoveAttribute(indexItem, indexRow) {
      // console.log('RemoveAttribute ...');
      this.sortedContracts[indexItem].customerAttributes.splice(indexRow,1);
      this.NewcustomerAttributes.splice(indexRow,1);
      // console.log('RemoveAttribute end');
    },
    allDataEntered(customerId, productId, voucherExpiryDate){
  //    console.log ("allDataEntered ...");
      if (!customerId || !productId || !voucherExpiryDate){
        this.AllData = false;}
      else if (!this.checkVoucherDate(voucherExpiryDate)){
        this.AllData = false;
        }
      else {
        this.AllData = true;}
  //    console.log ("allDataEntered end");
      },
    resetVariables() {
      // console.log ("resetVariables ...");
      this.customerId = '';
      this.productId = '';
      this.voucherExpiry = '';
      this.AllData = false;
      // console.log ("resetVariables end");
      },
    AddNewContractAttribute(customerAttribute, AttrIndex){
  //     console.log ("AddNewContractAttribute ...");
      if (!commonFunctions.xssTest(customerAttribute)) {
        this.message = commonFunctions.xssMessage("Attributes")
        this.attributesOK = false;
        return
      }
      else {
        this.attributesOK = true;
        this.message = ''
      }
      let custAtrib = {name: customerAttribute, multiList: false}
      this.customerAttributes.splice(AttrIndex + 1, 0, custAtrib);
      this.customerAttributes.splice(AttrIndex + 2, 1);
  //     console.log ("AddNewContractAttribute end");
      },
      closeModal() {
 //       console.log("closeModal ...");
        this.indexContract = '';
        this.showModal = false;
 //       console.log("closeModal end");
        },
      openModal(customerAttribute,contractId, indexRow, indexContract) {
 //       console.log("openModal ...");
        if(!customerAttribute){return}
        this.contractId = contractId
        this.getAttributeValues(contractId, customerAttribute.name)
        this.attributeLabel = customerAttribute.name
        this.indexContract = indexContract
        this.indexRow = indexRow
        this.modalmessage = '';
        this.newAttributeValue = '';
        this.showModal = true;
   //     console.log("openModal end");
      },

      async getAttributeValues(contractId, label) {
  //       console.log("getAttributeValues ...")
        var limit = 1000;
        try {
          let filter = {label: {eq: label}}
          const QueryVariables = {contractId, filter, limit};
          const attributeValues = await API.graphql({
            query: additionalItemByContractId,
            variables: QueryVariables
          });
          this.attributeValues = attributeValues.data.additionalItemByContractId.items;
          if (!this.attributeValues.length){ this.noAttributes = true}
        }
        catch (error) {
        //  console.log(error)
          this.modalmessage = commonFunctions.displayError(error);
        }
  //       console.log('getAttributeValues end ...')
      },

      async AddAttributeValue(label, values) {
  //      console.log("AddAttributeValue ...")
        this.modalmessage = ''; 
        if (!commonFunctions.xssTest(values)) {
          this.modalmessage = commonFunctions.xssMessage("Attribute value")
          this.attributesOK = false;
          return
        }
        const contractId = this.contractId
        var UpdateValues
        UpdateValues = {contractId, label, values };
         try {
           await API.graphql({
             query: createAdditionalItem,
             variables: {input: UpdateValues},
           });
           this.newAttributeValue = '';
         }
         catch (error) {
         //  console.log(error)
           this.modalmessage = commonFunctions.displayError(error);
         }
                                                                  // Update contract customer attributes when there are defined values   
          this.sortedContracts[this.indexContract].customerAttributes[this.indexRow].multiList = true;
        try {
          UpdateValues = '';
          const id = this.contractId;
          this.custAttrib = this.sortedContracts[this.indexContract].customerAttributes;

          let customerAttributes = this.custAttrib;
          UpdateValues = {id, customerAttributes};
          await API.graphql({
            query: updateContract,
            variables: {input: UpdateValues},
          });
        }
        catch (error) {
        //  console.log(error)
          this.modalmessage = commonFunctions.displayError(error);
        }
         this.getAttributeValues(contractId, label)
 //       console.log("AddAttributeValue end")
      },

      async deleteAttributeValue(id){
  //      console.log("deleteAttributeValue ...")

        try{
          const deleteItem = {id};
          // console.log('contract =', deleteItem)
          await API.graphql({
            query: deleteAdditionalItem,
            variables: {input: deleteItem},
          });
        }
        catch (error) {
        //  console.log(error)
          this.modalmessage = commonFunctions.displayError(error);
        }
         
        this.getAttributeValues(this.contractId, this.attributeLabel)
                                                                      // set multiList to false when all values removed
        if (this.attributeValues.length == 1){
          this.sortedContracts[this.indexContract].customerAttributes[this.indexRow].multiList = false;
          try {
            const id = this.contractId;
            this.custAttrib = this.sortedContracts[this.indexContract].customerAttributes;
            let customerAttributes = this.custAttrib;
            let UpdateValues = {id, customerAttributes};
            await API.graphql({
              query: updateContract,
              variables: {input: UpdateValues},
            });
          }
          catch (error) {
          //  console.log(error)
            this.modalmessage = commonFunctions.displayError(error);
          }
        }

  //      console.log("deleteAttributeValue end")
      },
    sort: function(s) {
  //     console.log('sort ...');
      if(s === this.currentSort) {
        this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
      }
      this.currentSort = s;
      // console.log('sort end');
    },

                                                                // Formula to determine checksum
                                                                // Note would be simplier if charAt wasnt generating an error

    luhn_checksum(code) {
      // console.log('luhn_checksum ...')

      var char1 = Math.trunc(code/100000);
      var char2 = Math.trunc(code/10000);
      char2 = (char2 -(char1 * 10));
      if (char2 > 9) char2 = char2-9;
      var char3 = Math.trunc(code/1000);
      char3 = char3 -(char1 * 100) - (char2 * 10);
      if (char3 > 9) char3 = char3-9;
      var char4 = Math.trunc(code/100);
      char4 = (char4 -(char1 * 1000) - (char2 * 100) - (char3 * 10));
      if (char4 > 9) char4 = char4-9;
      var char5 = Math.trunc(code/10);
      char5 = char5 -(char1 * 10000) - (char2 * 1000) - (char3 * 100) - (char4 * 10);
      if (char5 > 9) char5 = char5-9;
      var char6 = (code -(char1 * 100000) - (char2 * 10000) - (char3 * 1000) - (char4 * 100) - (char5 * 10));
      char2 = char2 * 2
      char4 = char4 * 2
      char6 = char6 * 2
      var sum = (char1 + char2 + char3 + char4 + char5 + char6)*9
      // console.log('luhn_checksum end', sum % 10)
      return sum % 10
  },

    }
}
</script>
<style>

</style>
